<script setup lang="ts">
import { useMenuStore } from '~/stores/menu'

import type { Sg_TopBarItem } from '~/schema/types/generated'

interface Props {
    menuSection: Sg_TopBarItem[]
}
const { menuSection } = defineProps<Props>()
defineEmits(['handleDesktopMenu'])

const storeMenu = useMenuStore()
const { handleDesktopMenu } = storeMenu

const { sendMenuEvent } = useSendEvent()

const menuVal = defineModel<string>()

function handleModelUpdate(val: boolean) {
    // event handler called when value changes has a value: boolean
    // we have to convert it to string to store active menuVal value
    // https://www.radix-vue.com/components/menubar#root

    const value = String(val)
    if (menuVal.value === value || !value) {
        handleDesktopMenu(false)
    } else {
        handleDesktopMenu(true)
    }
    menuVal.value = value
    sendMenuEvent(value)
}
</script>

<template>
    <PlusBlogLpAtomMenubar
        class="hidden h-full md:flex"
        :model-value="menuVal"
        @update:model-value="handleModelUpdate"
    >
        <PlusBlogLpAtomMenubarMenu
            v-for="(cat, catIdx) in menuSection"
            :key="cat?.title || catIdx"
            :value="cat?.title ?? ''"
        >
            <PlusBlogLpAtomMenubarTrigger class="font-medium capitalize">
                {{ cat.title }}
            </PlusBlogLpAtomMenubarTrigger>
            <PlusBlogLpAtomMenubarContent :force-mount="menuVal === cat.title">
                <PlusBlogLpMoleculeMenuLinksDesktop
                    :cat-title="cat?.title ?? ''"
                    :categories="cat?.sg_containers"
                />
            </PlusBlogLpAtomMenubarContent>
        </PlusBlogLpAtomMenubarMenu>
    </PlusBlogLpAtomMenubar>
</template>
